<template>
  <base-container class="layout-column" ref="container" :isLoading="loading">
    <el-calendar v-model="selDate">
      <template #dateCell="{ date, data }">
        <div class="day-container">
          <div class="day-content">{{ data.day.split("-")[2] }}</div>
          <i v-if="data.isSelected" class="day-select el-icon-success"></i>
          <div
            v-if="scheduleMap[data.day] && scheduleMap[data.day].length"
            class="day-schedule day-schedule-success"
          >
            <span v-if="data.day == recommendDate"> 荐 </span>
          </div>
        </div>
      </template>
    </el-calendar>
    <artisan-group style="flex: 1; overflow-y: auto" title="预约资源">
      <template #header>
        预约资源:
        <el-select size="mini" v-model="roomId">
          <el-option
            :label="res.name"
            :value="res.id"
            v-for="res in resList"
            :key="res.id"
          >
            <el-row type="flex" justify="space-between" align="middle">
              <span> {{ res.name }}</span>
              <b
                v-show="res.id == recommendRoomId"
                class="color-danger margin-7"
              >
                荐
              </b>
            </el-row>
          </el-option>
        </el-select>
      </template>
      <el-row
        v-if="scheduleMap[scheduleDate] && scheduleMap[scheduleDate].length"
      >
        <el-col
          :span="12"
          v-for="(schedule, i) in scheduleMap[scheduleDate]"
          :key="i"
          class="padding5 align-center"
        >
          <div
            class="schedule-item"
            :class="getScheduleClass(schedule)"
            size="mini"
            border
            @click="selectSchedule(schedule)"
          >
            <b>{{ schedule.startPoint }}-{{ schedule.endPoint }}</b>
            <div>
              (
              <b>{{ schedule.resCount }}</b>
              <b class="margin-h5">/</b>
              <b>{{ schedule.totalCount }}</b>
              )
            </div>
            <b
              v-show="schedule.id == recommendScheduleId"
              class="schedule-item-recommend color-danger"
            >
              荐
            </b>
            <i
              v-if="schedule.id == scheduleId"
              class="schedule-select el-icon-success"
            ></i>
          </div>
        </el-col>
      </el-row>
      <div v-else>
        <el-empty description="暂无排班" :image-size="200"></el-empty>
      </div>
    </artisan-group>
    <el-row
      style="padding: 0 5px; background-color: white"
      type="flex"
      justify="space-between"
      align="middle"
      v-show="billId"
    >
      <el-checkbox size="mini" v-model="isForce"> 强制预约 </el-checkbox>
      <el-button
        type="primary"
        size="mini"
        @click="confirmReserve"
        icon="el-icon-check"
      >
        {{ btnTitle }}
      </el-button>
    </el-row>
  </base-container>
</template>

<script>
import { getSchedules, recommend, reserve, change } from "@/api/jy/reserve";
import moment from "moment";
export default {
  props: {
    billId: {
      type: String,
      default: "",
    },
    resDate: {
      type: String,
      default: "",
    },
    resId: {
      type: String,
      default: "",
    },
    resScheduleId: {
      type: String,
      default: "",
    },
    isRecommend: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      selDate: this.resDate ? moment(this.resDate).toDate() : new Date(),
      scheduleId: this.resScheduleId,
      resList: [],
      roomId: this.resId,
      isForce: false,
      loading: false,
      recommendDate: "",
      recommendRoomId: "",
      recommendScheduleId: "",
    };
  },
  computed: {
    scheduleMap() {
      let res = this.resList.find((c) => c.id == this.roomId);
      let map = {};
      if (res && res.schedules.length) {
        res.schedules.forEach((c) => {
          if (map[c.scheduleDate]) {
            map[c.scheduleDate].push(c);
          } else {
            map[c.scheduleDate] = [c];
          }
        });
      }
      return map;
    },
    scheduleDate() {
      return moment(this.selDate).format("YYYY-MM-DD");
    },
    btnTitle() {
      if (this.rows.length > 1) {
        return this.isRecommend ? "批量预约" : "批量改约";
      } else {
        return this.isRecommend ? "确认预约" : "确认改约";
      }
    },
  },
  watch: {
    billId() {
      this.scheduleId = this.resScheduleId;
      this.roomId = this.resId;
      this.selDate = this.resDate ? moment(this.resDate).toDate() : new Date();
      this.loadData();
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      if (this.billId) {
        this.loading = true;
        getSchedules(this.billId)
          .then((res) => {
            this.resList = res.data.data;
            this.loading = false;
            recommend(this.billId).then((res) => {
              const data = res.data.data;
              this.recommendDate = data.reserveDate;
              this.recommendRoomId = data.resourceId;
              this.recommendScheduleId = data.scheduleId;
              if (this.isRecommend) {
                this.roomId = data.resourceId;
                this.selDate = moment(data.reserveDate).toDate();
                this.scheduleId = data.scheduleId;
              }
            });
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    getScheduleClass(detail) {
      if (this.reservable(detail)) {
        return this.scheduleId == detail.id ? "schedule-item-select" : "";
      } else {
        return "schedule-item-disabled";
      }
    },
    reservable(detail) {
      let able = false;
      let current = moment().format("YYYY-MM-DD");
      let point = moment().format("HH:mm");
      if (detail.scheduleDate == current) {
        able = detail.endPoint > point;
      } else if (detail.scheduleDate > current) {
        able = true;
      }
      if (able) {
        if (detail.status == "full") {
          able = this.isForce;
        } else if (detail.status == "stop") {
          able = false;
        }
      }
      return able;
    },
    selectSchedule(schedule) {
      if (this.reservable(schedule)) {
        this.scheduleId = schedule.id;
      }
    },
    confirmReserve() {
      if (!this.scheduleId) {
        this.$message({
          type: "warning",
          message: "请选择要预约的日期时段！",
        });
        return;
      }

      let data = {};
      let billIds = "";
      if (this.rows.length > 1) {
        let editRow = this.rows.filter((r) => r.id == this.billId);
        if (editRow.length < 1) {
          this.$message({
            type: "error",
            message: "批量预约请勾选当前申请单！",
          });
          return;
        }
        let patientIdFlag = this.groupBy(this.rows, "patientId");
        if (patientIdFlag) {
          this.$message({
            type: "error",
            message: "不同患者不能批量预约！",
          });
          return;
        }

        let exeDeptFlag = this.groupBy(this.rows, "exeDeptId");
        if (exeDeptFlag) {
          this.$message({
            type: "error",
            message: "检查科室不一样不能批量预约！",
          });
          return;
        }

        let newRow = this.rows.filter(
          (r) =>
            r.status == "wait" || r.status == "cancel" || r.status == "stop"
        );
        if (newRow.length != 0 && newRow.length != this.rows.length) {
          this.$message({
            type: "error",
            message: "已预约的申请单请先取消预约再批量预约！",
          });
          return;
        }
        billIds = this.rows.map((c) => c.id).join(",");
        data = {
          applyNo: this.billId,
          periodId: this.scheduleId,
          isForce: this.isForce,
          batchIds: billIds,
        };
      } else {
        data = {
          applyNo: this.billId,
          periodId: this.scheduleId,
          isForce: this.isForce,
        };
      }

      this.$refs.container
        .confirm({ msg: "确认预约？", width: "100%" })
        .then((res) => {
          this.loading = true;
          let opAxios = this.isRecommend ? reserve : change;
          opAxios(data)
            .then(() => {
              this.$message({
                type: "success",
                message: "预约成功！",
              });
              let res = this.resList.find((c) => c.id == this.roomId);
              let schedule = res.schedules.find((c) => c.id == this.scheduleId);
              this.$emit("reserved", res, schedule, billIds);
              this.loading = false;
              this.loadData();
            })
            .catch(() => {
              this.loading = false;
            });
        });
    },
    groupBy(arr, field) {
      let flag = false;
      arr.forEach((a) => {
        arr.forEach((a1) => {
          if (a[field] != a1[field]) {
            flag = true;
          }
        });
      });
      return flag;
    },
  },
};
</script>

<style lang="scss" scoped>
.day-container {
  position: relative;
  height: 40px;
}

.day-content {
  height: 50px;
  line-height: 50px;
  text-align: center;
}

.day-select {
  display: block;
  position: absolute;
  bottom: 2px;
  right: 2px;
  height: 15px;
  color: #f56c6c;
}

.day-schedule {
  font-size: smaller;
  display: block;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 25px;
  height: 25px;
  line-height: 20px;
}

.day-schedule-danger {
  background-image: url("/img/triangle_danger.png");
  background-repeat: no-repeat;
  background-size: cover;
  color: #fff;
}

.day-schedule-success {
  background-image: url("/img/triangle_success.png");
  background-repeat: no-repeat;
  background-size: cover;
  color: #fff;
}
.schedule-item {
  border: 1px #dcdfe6 solid;
  padding: 5px;
  cursor: pointer;
  position: relative;
}
.schedule-item-recommend {
  position: absolute;
  top: 0;
  right: 3px;
}
.schedule-item-select {
  border: 1px #409eff solid;
  color: #409eff;
}
.schedule-item-disabled {
  color: #dcdfe6;
}
.schedule-select {
  display: block;
  position: absolute;
  top: 20px;
  left: 7px;
  color: #f56c6c;
}
</style>
